import * as React from "react";
import { Drawer, DrawerContent, DrawerHeader } from "@/components/atoms/drawer";
import type { SystemGroup } from "@/types";
import { useNavigate } from "@tanstack/react-router";
import { generateUrl } from "@/components/helpers/systemHelpers";
import { Button } from "@/components/atoms/button";
import { X } from "lucide-react";
import AccountMenuOptions from "@/components/atoms/AccountMenuOptions";
import { DrawerFooter } from "@/components/atoms/drawer";

export type SidebarDrawerProps = {
  isOpen: boolean;
  toggleOpen: () => void;
  systems?: SystemGroup[];
  userIsLoggedIn: boolean;
};

export function SidebarMenu(props: SidebarDrawerProps) {
  const navigate = useNavigate();
  const systems: SystemGroup[] = props.systems || [];

  const navigateTo = (to: string) => () => {
    props.toggleOpen();
    navigate({ to });
  };
  return (
    <Drawer
      direction="right"
      open={props.isOpen}
      onOpenChange={props.toggleOpen}
    >
      <DrawerContent>
        <div className="drawer-content overflow-y-auto sidebar-menu">
          <DrawerHeader className="border-b">
            <div className="flex flew-row items-center justify-between">
              <div className="basis-2/3">
                <h1 className="text-5xl">Menu</h1>
              </div>
              <div className="basis-1/3 flex items-center justify-end">
                <button onClick={props.toggleOpen}>
                  <X size={48} />
                </button>
              </div>
            </div>
          </DrawerHeader>
          <div className="flex flex-col gap-y-4 p-4">
            <div className="flex-1">
              <h3 className="text-3xl">
                <a onClick={navigateTo("/")}>Home</a>
              </h3>
            </div>
            <div className="flex-1">
              <h3 className="text-3xl">
                <a onClick={navigateTo("/systems")}>Bikes</a>
              </h3>
              <ul className="pt-4">
                {systems.map((system) => (
                  <li className="p-1" key={system._id}>
                    <a
                      className="text-xl"
                      onClick={navigateTo(generateUrl(system))}
                    >
                      {system.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex-1" onClick={navigateTo("/my-account")}>
              <h3 className="text-3xl">My Account</h3>
              <AccountMenuOptions isLoggedIn={props.userIsLoggedIn} />
            </div>
            <div className="flex-1" onClick={navigateTo("/contact-us")}>
              <h3 className="text-3xl">Contact Us</h3>
            </div>
          </div>
        </div>
        <DrawerFooter>              
          <Button
                className="w-full"
                variant="secondary"
                onClick={props.toggleOpen}
              >
                Close
              </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
